/**
 * Asserts that the provided value is defined.
 * If the assertion fails and the value is undefined, an error will be thrown.
 *
 * @template T - The type of the value to be asserted.
 * @param {T | undefined} value - The value to be asserted as defined.
 *
 * @returns {void}
 *
 * @throws {Error} - Throws an error if the value is undefined.
 */
export const assertIsDefined: <T>(value: T | undefined) => asserts value is T = value => {
  if (typeof value === 'undefined') {
    throw new Error('Unexpected undefined value!');
  }
};
